import React from 'react';
import styles from './notfound.module.css';

function Index(props) {
    return (
        <div className={styles.container}>
            <h1>Page not found</h1>
        </div>
    );
}

export default Index;
